import {
  FaRegEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube
} from 'react-icons/fa6';

const Footer = () => {
  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Expertise', href: '#expertise' },
    { name: 'Experience', href: '#experience' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Distributed Systems',
    'Microservices Architecture',
    'FinTech Infrastructure',
    'Event-Driven Systems',
    'Regulatory Compliance',
    'Engineering Leadership'
  ];

  return (
    <footer className='bg-secondary text-secondary-foreground'>
      <div className='container mx-auto px-4 lg:px-8 py-16'>
        <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12'>
          {/* Brand */}
          <div className='lg:col-span-1'>
            <h3 className='text-2xl font-bold gradient-text mb-4'>
              Yomi Akande
            </h3>
            <p className='text-secondary-foreground/80 mb-6 leading-relaxed'>
              Technology Expert & Consultant driving innovation and digital
              transformation across Africa and beyond.
            </p>
            <div className='flex space-x-4'>
              <a
                href='https://www.linkedin.com/in/yomiakande/'
                target='_blank'
                className='bg-secondary-foreground/10 p-2 rounded-lg hover:bg-primary transition-colors'
                aria-label='LinkedIn'
              >
                <FaLinkedinIn className='w-5 h-5' />
              </a>
              <a
                href='https://x.com/IamYomiAkande'
                target='_blank'
                className='bg-secondary-foreground/10 p-2 rounded-lg hover:bg-primary transition-colors'
                aria-label='Twitter'
              >
                <FaXTwitter className='w-5 h-5' />
              </a>
              <a
                href='#'
                target='_blank'
                className='bg-secondary-foreground/10 p-2 rounded-lg hover:bg-primary transition-colors'
                aria-label='Youtube'
              >
                <FaYoutube className='w-5 h-5' />
              </a>
              <a
                href='https://www.instagram.com/IamYomiAkande/'
                target='_blank'
                className='bg-secondary-foreground/10 p-2 rounded-lg hover:bg-primary transition-colors'
                aria-label='Instagram'
              >
                <FaInstagram className='w-5 h-5' />
              </a>
              <a
                href='mailto:hello@yomiakande.com'
                className='bg-secondary-foreground/10 p-2 rounded-lg hover:bg-primary transition-colors'
                aria-label='Email'
              >
                <FaRegEnvelope className='w-5 h-5' />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className='text-lg font-semibold mb-6'>Quick Links</h4>
            <ul className='space-y-3'>
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className='text-secondary-foreground/80 hover:text-primary transition-colors flex items-center'
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className='text-lg font-semibold mb-6'>Services</h4>
            <ul className='space-y-3'>
              {services.map((service) => (
                <li key={service}>
                  <span className='text-secondary-foreground/80 text-sm'>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className='text-lg font-semibold mb-6'>Contact</h4>
            <div className='space-y-4'>
              <div className='flex items-start space-x-3'>
                <FaRegEnvelope className='w-5 h-5 mt-0.5 text-primary' />
                <div>
                  <p className='text-sm text-secondary-foreground/60'>Email</p>
                  <a
                    href='mailto:hello@yomiakande.com'
                    className='text-secondary-foreground/80 hover:text-primary transition-colors'
                  >
                    hello@yomiakande.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className='border-t border-secondary-foreground/20 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            <p className='text-secondary-foreground/60 text-sm'>
              © {new Date().getFullYear()} Yomi Akande. All rights reserved.
            </p>
            {/* <div className='flex space-x-6 text-sm'>
              <a
                href='#'
                className='text-secondary-foreground/60 hover:text-primary transition-colors'
              >
                Privacy Policy
              </a>
              <a
                href='#'
                className='text-secondary-foreground/60 hover:text-primary transition-colors'
              >
                Terms of Service
              </a>
              <a
                href='#'
                className='text-secondary-foreground/60 hover:text-primary transition-colors'
              >
                Cookie Policy
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
